/** Web fontları global.css üzerinden yerelden yüklenir. */
export function useFontlar(): [boolean, Error | null] {
  return [true, null];
}
